import { useNavigation } from '@atom/hooks/useNavigation';
import { Button, Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import TopNavigationBar from '../navigation/TopNavigationBar';

import classes from './errorPages.module.css';

const styles = {
  icon: {
    fontSize: '75px',
  },
  button: {
    marginTop: '2rem',
  },
};

const UnknownError = () => {
  const [, { Link }] = useNavigation();
  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <TopNavigationBar />
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.content}>
          <Icon style={styles.icon} color={colors.neutral.silver}>
            error
          </Icon>
          <div className={classes.title}>Unknown Error</div>
          <div className={classes.subtext}>You've encountered an issue.</div>
          <div className={classes.subtext}>
            Please go to the homepage or contact support.
          </div>
          <Link to={'/'} style={styles.button}>
            <Button variant="contained" color="primary">
              Go To Homepage
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UnknownError;
